import {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {rpc_getServerInfo} from "./rpc";
import {HubConnectionState} from "@microsoft/signalr";
import {useRPC, useSocket} from "./SocketContext";

const Context = createContext<ServerInfo>(null!);

export default function ServerInfoContext(props: {children: ReactNode}) {
    const socket = useSocket()

    const [serverInfo, setServerInfo] = useState<ServerInfo>({ serverDisabled: false, serverConnected: false, pluginOutdated: false, backendConnected: false, backendConnecting: true, displayName: undefined})

    useRPC(socket, "OnServerInfo", (info: ServerInfo) => {
        console.log("OnServerInfo")
        info.backendConnected = true
        setServerInfo(info)
    })

    useEffect(() => {
        if (socket.isConnected){
            console.log("[SOCKET] Connected, request server info")
            rpc_getServerInfo(socket).then(info => {
                if (info){
                    info.backendConnected = true
                    setServerInfo(info)
                }
            })
        }
        else if (socket.connection.current?.state === HubConnectionState.Disconnected){
            setServerInfo({
                serverConnected: serverInfo.serverConnected,
                serverDisabled: serverInfo.serverDisabled,
                pluginOutdated: serverInfo.pluginOutdated,
                displayName: serverInfo.displayName,
                backendConnected: false,
                backendConnecting: false,
            })
        }
        else if (socket.connection.current?.state === HubConnectionState.Reconnecting){
            setServerInfo({
                serverConnected: serverInfo.serverConnected,
                serverDisabled: serverInfo.serverDisabled,
                pluginOutdated: serverInfo.pluginOutdated,
                displayName: serverInfo.displayName,
                backendConnected: false,
                backendConnecting: true,
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket])

    return (
        <Context.Provider value={serverInfo}>
            {props.children}
        </Context.Provider>
    )
}

export const useServerInfo = () => useContext(Context)

export interface ServerInfo{
    displayName?: string
    serverDisabled: boolean
    serverConnected: boolean
    pluginOutdated: boolean
    backendConnected: boolean
    backendConnecting: boolean
}